/**
 * Identidade e canais de contato do JurisApp — fonte única.
 *
 * O domínio oficial é `jurisapp.ia.br` (não temos `jurisapp.com.br`). Nunca
 * hardcodar domínio/email em páginas: derive sempre de `SITE_DOMAIN` aqui.
 */
export const SITE_DOMAIN = 'jurisapp.ia.br';
export const SITE_URL = `https://${SITE_DOMAIN}`;

/**
 * A pessoa jurídica que opera o JurisApp, como consta no cartão CNPJ. Vai no
 * rodapé do site: é o que o consumidor procura e o que parceiros cruzam com o
 * registro oficial (a verificação de empresa da Meta recusa site sem isto).
 */
export const COMPANY = {
  razaoSocial: 'LAST IAR TECH LTDA',
  cnpj: '66.869.457/0001-45',
  endereco: 'Av. Governador Osman Loureiro, 49, Sala 908-A, Cond. Business Tower',
  bairro: 'Mangabeiras',
  cidadeUf: 'Maceió/AL',
  cep: '57037-630',
} as const;

export const CONTACT = {
  email: `contato@${SITE_DOMAIN}`,
  comercial: `comercial@${SITE_DOMAIN}`,
  /**
   * Telefone/WhatsApp ainda não definidos. Deixe vazio — a UI omite o canal
   * quando não há número. NUNCA preencher com placeholder falso
   * (ex.: "(11) 99000-0000"), pois fica visível em produção.
   */
  whatsapp: '',
  telefone: '',
} as const;
